/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { SetStateAction, useState } from "react";

import { useTranslation } from "react-i18next";

import { useDrawerStore } from "@/stores/useDrawerStore";
import Badge from "@mui/material/Badge";

import {
  colors,
  NotificationsOutlineIcon
} from "@dotnet/telematics-design-system";

import { dummyNotificationsCount } from "../../../../mocks/dummyData/data";
import { MenuAnchorEl, useMediaQueries } from "../../../../shared";
import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "../../../Button/Button";
import { useStyles } from "../../styles";
import NotificationsDesktop from "./components/NotificationsDesktop";
import NotificationsMobile from "./components/NotificationsMobile";

const Notifications = () => {
  const { toMd } = useMediaQueries();
  const { t } = useTranslation();

  const setIsMobileDrawerOpen = useDrawerStore(
    state => state.setIsMobileDrawerOpen
  );

  const [anchorEl, setAnchorEl] = useState<MenuAnchorEl>(null);
  const [isMobileNotificationsOpen, setIsMobileNotificationsOpen] =
    useState(false);

  const { notificationsButton } = useStyles();

  const openNotificationsMenu = (e: {
    currentTarget: SetStateAction<MenuAnchorEl>;
  }) => setAnchorEl(e.currentTarget);

  const closeNotificationsMenu = () => setAnchorEl(null);

  const openMobileNotifications = () => setIsMobileNotificationsOpen(true);

  const closeMobileNotifications = () => {
    setIsMobileDrawerOpen(false);
    setIsMobileNotificationsOpen(false);
  };

  return (
    <>
      <Button
        disableRipple={toMd}
        fullWidth={toMd}
        variant={BUTTON_VARIANTS.IconLeft}
        size={BUTTON_SIZES.Small}
        color={BUTTON_COLORS.White}
        icon={
          <Badge
            badgeContent={dummyNotificationsCount}
            sx={{
              "& .MuiBadge-badge": {
                backgroundColor: colors.red600,
                color: colors.white,
                fontSize: "12px",
                fontWeight: "600",
                letterSpacing: "0.4px",
                padding: "0 5px"
              }
            }}
          >
            <NotificationsOutlineIcon />
          </Badge>
        }
        onClick={toMd ? openMobileNotifications : openNotificationsMenu}
        css={css(notificationsButton)}
      >
        {t("Notifications##notifications")}
      </Button>

      {toMd ? (
        <NotificationsMobile
          isOpen={isMobileNotificationsOpen}
          close={closeMobileNotifications}
        />
      ) : (
        <NotificationsDesktop
          anchorEl={anchorEl}
          close={closeNotificationsMenu}
        />
      )}
    </>
  );
};

export default Notifications;
